// @flow
import SidebarIssueItem from './SidebarIssueItem';

export default SidebarIssueItem;
